import DynamicFormFieldDefinitionModelBase from '../_generated/modelBases/dynamic-form-field-definition-model-base';

export default class DynamicFormFieldDefinitionModel extends DynamicFormFieldDefinitionModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
